/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMemberCategoryInternalV2MembersCategoriesPost } from '../fn/members-internal-v-2/create-member-category-internal-v-2-members-categories-post';
import { CreateMemberCategoryInternalV2MembersCategoriesPost$Params } from '../fn/members-internal-v-2/create-member-category-internal-v-2-members-categories-post';
import { createMemberInternalV2MembersPost } from '../fn/members-internal-v-2/create-member-internal-v-2-members-post';
import { CreateMemberInternalV2MembersPost$Params } from '../fn/members-internal-v-2/create-member-internal-v-2-members-post';
import { deleteMemberCategoryInternalV2MembersCategoriesIdDelete } from '../fn/members-internal-v-2/delete-member-category-internal-v-2-members-categories-id-delete';
import { DeleteMemberCategoryInternalV2MembersCategoriesIdDelete$Params } from '../fn/members-internal-v-2/delete-member-category-internal-v-2-members-categories-id-delete';
import { deleteMemberInternalV2MembersOrgIdDelete } from '../fn/members-internal-v-2/delete-member-internal-v-2-members-org-id-delete';
import { DeleteMemberInternalV2MembersOrgIdDelete$Params } from '../fn/members-internal-v-2/delete-member-internal-v-2-members-org-id-delete';
import { getAllMemberCategoriesInternalV2MembersCategoriesAllGet } from '../fn/members-internal-v-2/get-all-member-categories-internal-v-2-members-categories-all-get';
import { GetAllMemberCategoriesInternalV2MembersCategoriesAllGet$Params } from '../fn/members-internal-v-2/get-all-member-categories-internal-v-2-members-categories-all-get';
import { MemberCategories } from '../models/member-categories';
import { MembersWithoutSupplierData } from '../models/members-without-supplier-data';
import { updateMemberCategoryInternalV2MembersCategoriesIdPatch } from '../fn/members-internal-v-2/update-member-category-internal-v-2-members-categories-id-patch';
import { UpdateMemberCategoryInternalV2MembersCategoriesIdPatch$Params } from '../fn/members-internal-v-2/update-member-category-internal-v-2-members-categories-id-patch';
import { updateMemberInternalV2MembersOrgIdPatch } from '../fn/members-internal-v-2/update-member-internal-v-2-members-org-id-patch';
import { UpdateMemberInternalV2MembersOrgIdPatch$Params } from '../fn/members-internal-v-2/update-member-internal-v-2-members-org-id-patch';

@Injectable({ providedIn: 'root' })
export class MembersInternalV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createMemberInternalV2MembersPost()` */
  static readonly CreateMemberInternalV2MembersPostPath = '/_internal/v2/members';

  /**
   * Create Member.
   *
   * Create a new member record.
   *
   * This endpoint creates a new member document for internal use.
   *
   * Args:
   *     member_in (schemas.MembersCreateInInternal): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.Members: The newly created member record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMemberInternalV2MembersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberInternalV2MembersPost$Response(params: CreateMemberInternalV2MembersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return createMemberInternalV2MembersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Member.
   *
   * Create a new member record.
   *
   * This endpoint creates a new member document for internal use.
   *
   * Args:
   *     member_in (schemas.MembersCreateInInternal): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.Members: The newly created member record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMemberInternalV2MembersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberInternalV2MembersPost(params: CreateMemberInternalV2MembersPost$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.createMemberInternalV2MembersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `deleteMemberInternalV2MembersOrgIdDelete()` */
  static readonly DeleteMemberInternalV2MembersOrgIdDeletePath = '/_internal/v2/members/{org_id}';

  /**
   * Delete Member.
   *
   * Remove a member record by organization ID.
   *
   * This endpoint deletes a member associated with the provided `org_id` if it exists.
   * It validates the tenant, authentication token, and organization permissions before performing the deletion.
   *
   * Args:
   *     tenant (Any): Tenant information extracted from the request context.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     org_id (str): The ID of the organization to delete the member for.
   *
   * Raises:
   *     HTTPException:
   *         - 400 if the member/organization does not exist.
   *
   * Returns:
   *     204 No Content: When the member is successfully deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMemberInternalV2MembersOrgIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMemberInternalV2MembersOrgIdDelete$Response(params: DeleteMemberInternalV2MembersOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMemberInternalV2MembersOrgIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Member.
   *
   * Remove a member record by organization ID.
   *
   * This endpoint deletes a member associated with the provided `org_id` if it exists.
   * It validates the tenant, authentication token, and organization permissions before performing the deletion.
   *
   * Args:
   *     tenant (Any): Tenant information extracted from the request context.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     org_id (str): The ID of the organization to delete the member for.
   *
   * Raises:
   *     HTTPException:
   *         - 400 if the member/organization does not exist.
   *
   * Returns:
   *     204 No Content: When the member is successfully deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMemberInternalV2MembersOrgIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMemberInternalV2MembersOrgIdDelete(params: DeleteMemberInternalV2MembersOrgIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.deleteMemberInternalV2MembersOrgIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateMemberInternalV2MembersOrgIdPatch()` */
  static readonly UpdateMemberInternalV2MembersOrgIdPatchPath = '/_internal/v2/members/{org_id}';

  /**
   * Update Member.
   *
   * Update a member record.
   *
   * Args:
   *     member_in (schemas.MembersCreateInInternal): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     org_id: org id of the member record
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMemberInternalV2MembersOrgIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberInternalV2MembersOrgIdPatch$Response(params: UpdateMemberInternalV2MembersOrgIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return updateMemberInternalV2MembersOrgIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Member.
   *
   * Update a member record.
   *
   * Args:
   *     member_in (schemas.MembersCreateInInternal): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     org_id: org id of the member record
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMemberInternalV2MembersOrgIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberInternalV2MembersOrgIdPatch(params: UpdateMemberInternalV2MembersOrgIdPatch$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.updateMemberInternalV2MembersOrgIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `getAllMemberCategoriesInternalV2MembersCategoriesAllGet()` */
  static readonly GetAllMemberCategoriesInternalV2MembersCategoriesAllGetPath = '/_internal/v2/members/categories/all';

  /**
   * Get All Member Categories.
   *
   * Retrieve all member categories
   * Args:
   *     org (Any): Organization details for permission checking.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     list[schemas.MemberCategories]: A list of all Member Categories records
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMemberCategoriesInternalV2MembersCategoriesAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMemberCategoriesInternalV2MembersCategoriesAllGet$Response(params: GetAllMemberCategoriesInternalV2MembersCategoriesAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberCategories>>> {
    return getAllMemberCategoriesInternalV2MembersCategoriesAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Member Categories.
   *
   * Retrieve all member categories
   * Args:
   *     org (Any): Organization details for permission checking.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     list[schemas.MemberCategories]: A list of all Member Categories records
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMemberCategoriesInternalV2MembersCategoriesAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMemberCategoriesInternalV2MembersCategoriesAllGet(params: GetAllMemberCategoriesInternalV2MembersCategoriesAllGet$Params, context?: HttpContext): Observable<Array<MemberCategories>> {
    return this.getAllMemberCategoriesInternalV2MembersCategoriesAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MemberCategories>>): Array<MemberCategories> => r.body)
    );
  }

  /** Path part for operation `createMemberCategoryInternalV2MembersCategoriesPost()` */
  static readonly CreateMemberCategoryInternalV2MembersCategoriesPostPath = '/_internal/v2/members/categories';

  /**
   * Create Member Category.
   *
   * Create a new member category record.
   *
   * This endpoint creates a new member category document for internal use.
   *
   * Args:
   *     member_in (schemas.MemberCategoriesCreate): Input schema containing member category details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.Members: The newly created member record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMemberCategoryInternalV2MembersCategoriesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberCategoryInternalV2MembersCategoriesPost$Response(params: CreateMemberCategoryInternalV2MembersCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MemberCategories>> {
    return createMemberCategoryInternalV2MembersCategoriesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Member Category.
   *
   * Create a new member category record.
   *
   * This endpoint creates a new member category document for internal use.
   *
   * Args:
   *     member_in (schemas.MemberCategoriesCreate): Input schema containing member category details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.Members: The newly created member record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMemberCategoryInternalV2MembersCategoriesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberCategoryInternalV2MembersCategoriesPost(params: CreateMemberCategoryInternalV2MembersCategoriesPost$Params, context?: HttpContext): Observable<MemberCategories> {
    return this.createMemberCategoryInternalV2MembersCategoriesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MemberCategories>): MemberCategories => r.body)
    );
  }

  /** Path part for operation `deleteMemberCategoryInternalV2MembersCategoriesIdDelete()` */
  static readonly DeleteMemberCategoryInternalV2MembersCategoriesIdDeletePath = '/_internal/v2/members/categories/{id}';

  /**
   * Delete Member Category.
   *
   * Remove a member category record by id.
   *
   * Args:
   *     tenant (Any): Tenant information extracted from the request context.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     id (str): The ID of the member category record to be deleted
   *
   * Raises:
   *     HTTPException:
   *         - 400 if the member/organization does not exist.
   *
   * Returns:
   *     204 No Content: When the member is successfully deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMemberCategoryInternalV2MembersCategoriesIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMemberCategoryInternalV2MembersCategoriesIdDelete$Response(params: DeleteMemberCategoryInternalV2MembersCategoriesIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMemberCategoryInternalV2MembersCategoriesIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Member Category.
   *
   * Remove a member category record by id.
   *
   * Args:
   *     tenant (Any): Tenant information extracted from the request context.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     id (str): The ID of the member category record to be deleted
   *
   * Raises:
   *     HTTPException:
   *         - 400 if the member/organization does not exist.
   *
   * Returns:
   *     204 No Content: When the member is successfully deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMemberCategoryInternalV2MembersCategoriesIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMemberCategoryInternalV2MembersCategoriesIdDelete(params: DeleteMemberCategoryInternalV2MembersCategoriesIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.deleteMemberCategoryInternalV2MembersCategoriesIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateMemberCategoryInternalV2MembersCategoriesIdPatch()` */
  static readonly UpdateMemberCategoryInternalV2MembersCategoriesIdPatchPath = '/_internal/v2/members/categories/{id}';

  /**
   * Update Member Category.
   *
   * Update a member category record.
   *
   * Args:
   *     member_in (schemas.MemberCategoriesUpdate): Input schema containing member category details for update.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     id: id of the member category record
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.MemberCategories: The updated member category record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMemberCategoryInternalV2MembersCategoriesIdPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberCategoryInternalV2MembersCategoriesIdPatch$Response(params: UpdateMemberCategoryInternalV2MembersCategoriesIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MemberCategories>> {
    return updateMemberCategoryInternalV2MembersCategoriesIdPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Member Category.
   *
   * Update a member category record.
   *
   * Args:
   *     member_in (schemas.MemberCategoriesUpdate): Input schema containing member category details for update.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *     id: id of the member category record
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an internal admin user
   *
   * Returns:
   *     schemas.MemberCategories: The updated member category record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMemberCategoryInternalV2MembersCategoriesIdPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberCategoryInternalV2MembersCategoriesIdPatch(params: UpdateMemberCategoryInternalV2MembersCategoriesIdPatch$Params, context?: HttpContext): Observable<MemberCategories> {
    return this.updateMemberCategoryInternalV2MembersCategoriesIdPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MemberCategories>): MemberCategories => r.body)
    );
  }

}
